import { RG_TYPE } from '../../types/rg-type.js';
import { ROOM_TYPE } from '../../types/room-type.js';

const DefaultRoom = {
    type: RG_TYPE.Room,
    name: 'new room',
    color: '#29ad39',
    size: [2, 2, 2.555],
    anchor: [0.5, 0, 0.5],
    children: [],
    data: { type: ROOM_TYPE.Generic }
};

export { DefaultRoom };
//# sourceMappingURL=default-room.js.map
